import { thumbnails } from "./assets";
import { PLAYTIME_PHASE } from "./constants";

const { LOGIN, EXPLORE, KEEPGOING } = PLAYTIME_PHASE;

/** @todo update region routes to specific one-click region routes */
const gameplayByRegion = {
  dreamspace: {
    [LOGIN]: "#ocCharacterCustomization",
    [EXPLORE]: "#region/2yEUZZIs7G8kbi62zHK3",
    [KEEPGOING]: "#region/2yEUZZIs7G8kbi62zHK3",
  },
  caves: {
    [EXPLORE]: "#ocp/GoEiu5mQNUtJ1IoqDHp6",
    [KEEPGOING]: "#region/5ZZEV28ul2WnnQW2arxH",
  },
  arctic: {
    [EXPLORE]: "#ocp/uAxT54weBukBrlf76MCL",
    [KEEPGOING]: "#region/qpy4jMcs23derdyB4keq",
  },
};

// Lesson 01 does not have discuss timers
const LESSON_01_TIMER_TIMES = {
  [LOGIN]: 5,
  [EXPLORE]: 3,
  [KEEPGOING]: 25,
};

const lesson01PollData = {
  pushbubble: {
    display: 1,
    label: "Poll 1",
    pollId: "pushbubble",
    question: "Why couldn’t Sol push the bubble?",
    choices: [
      {
        choiceId: "1",
        text: "There is no rule that says the bubble can be pushed",
      },
      { choiceId: "2", text: "Sol got trapped in the bubble" },
      { choiceId: "3", text: "Bubbles always pop when pushed" },
      { choiceId: "4", text: "Sol can only push crabs" },
    ],
    correctChoiceId: "1",
  },
};

const lesson02Data = {
  // display: 1,
  id: "lcr02",
  // name: 'Lesson 2', // LCR02
  // sequence: 'lcr02',
  data: {
    polls: {
      tinkering: {
        display: 1,
        pollId: "tinkering",
        label: "Poll 1",
        question:
          "Which of these is NOT something you would do while tinkering?",
        choices: [
          { choiceId: "1", text: "Walk onto an object" },
          { choiceId: "2", text: "Push an object" },
          { choiceId: "3", text: "Make or break a rule" },
          { choiceId: "4", text: "Give up and walk away" },
        ],
      },
      spikes: {
        display: 2,
        pollId: "spikes",
        label: "Poll 2",
        question:
          "Which state would you use on the SPIKES to make this happen?",
        choices: [
          { choiceId: "1", text: "WEAK", image: "text_weak" },
          { choiceId: "2", text: "BOOM", image: "text_boom" },
          { choiceId: "3", text: "SINK", image: "text_sink" },
        ],
      },
      fossil: {
        display: 3,
        pollId: "fossil",
        label: "Poll 3",
        question:
          "Which state would you use on the FOSSIL to make this happen?",
        choices: [
          { choiceId: "1", text: "WEAK", image: "text_weak" },
          { choiceId: "2", text: "BOOM", image: "text_boom" },
          { choiceId: "3", text: "SINK", image: "text_sink" },
        ],
      },
      water: {
        display: 4,
        pollId: "water",
        label: "Poll 4",
        question: "Which state would you use on the WATER to make this happen?",
        choices: [
          { choiceId: "1", text: "WEAK", image: "text_weak" },
          { choiceId: "2", text: "BOOM", image: "text_boom" },
          { choiceId: "3", text: "SINK", image: "text_sink" },
        ],
      },
    },
    slides:
      "https://9dots.slides.com/alexiscabrera/one-click-l2-pptx/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
  },
};

/** @todo longterm - save data as json */
export const playlistData = {
  tutorial: {
    display: 0,
    id: "tutorial",
    name: "Lesson 0",
    sequence: "onboarding",
    data: {
      /** @todo remove playlist property */
      playlist: {
        0: {
          display: 0,
          label: "",
          puzzles: {
            1: "XluB96ZEgKt2Oa2oYxUU",
            2: "QdmV0K8k7GlZaquZ5obJ",
            3: "53dLJeKpoXenbHNzwHA4",
            4: "IR0iRjJadRRKExuAKsl2",
            5: "uqeNDFLE6JaHZAgF4vGn",
            6: "juc2OAeeGrg1KbfpX8M3",
            7: "A0a5nf5jgKBlYRHGlPPc",
            8: "A5YUITJPekEi5S1VfmFM",
            9: "vj2wJGIEBn7AZcBynHZZ",
          },
        },
      },
    },
  },
  // soft launch
  softlaunch01: {
    id: "softlaunch01",
    data: {
      timerTimes: LESSON_01_TIMER_TIMES,
      gameplay: gameplayByRegion.dreamspace,
      polls: lesson01PollData,
      slides:
        "https://9dots.slides.com/sophiekansmith/spring-launch-lesson-1-video/#/playtime-login/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.softlaunch01,
      lessonNum: 1,
    },
  },
  softlaunch02: {
    id: "softlaunch02",
    data: {
      gameplay: gameplayByRegion.caves,
      polls: {
        helpful: {
          display: 1,
          label: "Poll 1",
          pollId: "helpful",
          question: "Which rule(s) are helpful for solving the problem?",
          choices: [
            {
              choiceId: "1",
              text: "SOL IS SINK",
              image: ["text_verdad", "text_is", "text_sink"],
            },
            {
              choiceId: "2",
              text: "FOSSIL IS SINK",
              image: ["text_fossil", "text_is", "text_sink"],
            },
            {
              choiceId: "3",
              text: "GOLD IS SINK",
              image: ["text_topaz", "text_is", "text_sink"],
            },
            {
              choiceId: "4",
              text: "Both 2 and 3",
            },
          ],
          correctChoiceId: "4",
        },
        spikes: {
          display: 2,
          label: "Poll 2",
          pollId: "spikes",
          question:
            "Which state block would you use on the CRYSTALS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
          correctChoiceId: "1",
        },
        fossils: {
          display: 3,
          label: "Poll 3",
          pollId: "fossils",
          question:
            "Which state block would you use on the FOSSILS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
          correctChoiceId: "2",
        },
      },
      slides:
        "https://9dots.slides.com/sophiekansmith/spring-launch-lesson-2-video/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.softlaunch02,
      lessonNum: 2,
    },
  },
  softlaunch03: {
    id: "softlaunch03",
    data: {
      gameplay: gameplayByRegion.arctic,
      polls: {
        observation: {
          display: 1,
          label: "Poll 1",
          pollId: "observation",
          question: "Which of Zorro's observations is the most useful?",
          choices: [
            { choiceId: "1", text: "The lava is orange" },
            { choiceId: "2", text: "There's a lot of snow" },
            { choiceId: "3", text: "There's a rule for ROCK IS DEFEAT" },
            { choiceId: "4", text: "Walking on lava seems scary" },
          ],
          correctChoiceId: "3",
        },
      },
      slides:
        "https://9dots.slides.com/sophiekansmith/spring-launch-lesson-3-video/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.softlaunch03,
      lessonNum: 3,
    },
  },
  oct2024lesson01: {
    id: "oct2024lesson01",
    data: {
      timerTimes: LESSON_01_TIMER_TIMES,
      gameplay: gameplayByRegion.dreamspace,
      polls: lesson01PollData,
      slides:
        "https://9dots.slides.com/selinaarjomand/oct-2024-txp-l1/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.octLesson01,
      lessonNum: 1,
    },
  },
  oct2024lesson02: {
    id: "oct2024lesson02",
    data: {
      gameplay: gameplayByRegion.caves,
      polls: {
        helpful: {
          display: 1,
          label: "Poll 1",
          pollId: "helpful",
          question: "Which rule(s) is helpful for solving the problem?",
          choices: [
            {
              choiceId: "1",
              text: "SOL IS SINK",
              image: ["text_verdad", "text_is", "text_sink"],
            },
            {
              choiceId: "2",
              text: "FOSSIL IS SINK",
              image: ["text_fossil", "text_is", "text_sink"],
            },
            {
              choiceId: "3",
              text: "GOLD IS SINK",
              image: ["text_topaz", "text_is", "text_sink"],
            },
            {
              choiceId: "4",
              text: "Both 2 and 3",
            },
          ],
          correctChoiceId: "4",
        },
        spikes: {
          display: 2,
          label: "Poll 2",
          pollId: "spikes",
          question:
            "Which state block would you use on the CRYSTALS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
          correctChoiceId: "1",
        },
        fossils: {
          display: 3,
          label: "Poll 3",
          pollId: "fossils",
          question:
            "Which state block would you use on the FOSSILS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
          correctChoiceId: "2",
        },
      },
      slides:
        "https://9dots.slides.com/selinaarjomand/oct-2024-txp-l2/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.octLesson02,
      lessonNum: 2,
    },
  },
  oct2024lesson03: {
    id: "oct2024lesson03",
    data: {
      gameplay: gameplayByRegion.arctic,
      polls: {
        observation: {
          display: 1,
          label: "Poll 1",
          pollId: "observation",
          question: "Which of Zorro's observations is the most helpful?",
          choices: [
            { choiceId: "1", text: "The lava is orange" },
            { choiceId: "2", text: "There's a lot of snow" },
            { choiceId: "3", text: "There's a rule for ROCK IS DEFEAT" },
            { choiceId: "4", text: "Walking on lava seems scary" },
          ],
          correctChoiceId: "3",
        },
      },
      slides:
        "https://9dots.slides.com/selinaarjomand/oct-2024-txp-l3/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.octLesson03,
      lessonNum: 3,
    },
  },
  sep2024lesson01clifford: {
    id: "sep2024lesson01clifford",
    data: {
      polls: lesson01PollData,
      slides:
        "https://9dots.slides.com/sophiekansmith/sept-2024-pilot-lesson-1-v3/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.sepLesson01Clifford,
    },
  },
  sep2024lesson01galicia: {
    id: "sep2024lesson01galicia",
    data: {
      polls: lesson01PollData,
      slides:
        "https://9dots.slides.com/sophiekansmith/sept-2024-pilot-lesson-1/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.sepLesson01Galicia,
    },
  },
  sep2024lesson01robles: {
    id: "sep2024lesson01robles",
    data: {
      polls: lesson01PollData,
      slides:
        "https://9dots.slides.com/sophiekansmith/sept-2024-pilot-lesson-1-v2/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.sepLesson01Robles,
    },
  },
  sep2024lesson01vargas: {
    id: "sep2024lesson01vargas",
    data: {
      polls: lesson01PollData,
      slides:
        "https://9dots.slides.com/sophiekansmith/sept-2024-pilot-lesson-1-v4/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.sepLesson01Vargas,
    },
  },
  sep2024lesson02: {
    id: "sep2024lesson02",
    data: {
      polls: {
        spikes: {
          display: 1,
          label: "Poll 1",
          pollId: "spikes",
          question:
            "Which state block would you use on the CRYSTALS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
          correctChoiceId: "1",
        },
        fossils: {
          display: 2,
          label: "Poll 2",
          pollId: "fossils",
          question:
            "Which state block would you use on the FOSSILS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
          correctChoiceId: "2",
        },
      },
      slides:
        "https://9dots.slides.com/sophiekansmith/sept-2024-pilot-lesson-2-v1/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.sepLesson02,
    },
  },
  sep2024lesson03: {
    id: "sep2024lesson03",
    data: {
      polls: {
        observation: {
          display: 1,
          label: "Poll 1",
          pollId: "observation",
          question: "Which of Zorro's observations is the most helpful?",
          choices: [
            { choiceId: "1", text: "The lava is orange" },
            { choiceId: "2", text: "There's a lot of snow" },
            { choiceId: "3", text: "There's a rule for ROCK IS DEFEAT" },
            { choiceId: "4", text: "Walking on lava seems scary" },
          ],
          correctChoiceId: "3",
        },
      },
      slides:
        "https://9dots.slides.com/sophiekansmith/sept-2024-pilot-lesson-3-v1/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.sepLesson03,
    },
  },
  pr01: {
    id: "pr01",
    data: {
      polls: lesson01PollData,
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-1/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson01,
    },
  },
  pr02: {
    id: "pr02",
    data: {
      polls: {
        spikes: {
          display: 1,
          label: "Poll 1",
          pollId: "spikes",
          question:
            "Which state block would you use on the SPIKES to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
        },
        fossils: {
          display: 2,
          label: "Poll 2",
          pollId: "fossils",
          question:
            "Which state block would you use on the FOSSILS to make this happen?",
          choices: [
            { choiceId: "1", text: "WEAK", image: "text_weak" },
            { choiceId: "2", text: "BOOM", image: "text_boom" },
            { choiceId: "3", text: "SINK", image: "text_sink" },
          ],
        },
      },
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-2/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson02,
    },
  },
  pr03: {
    id: "pr03",
    data: {
      polls: {
        blocking: {
          display: 1,
          label: "Poll 1",
          pollId: "blocking",
          question: "What is blocking us from the goal?",
          choices: [
            { choiceId: "1", text: "FIRE", image: "roastedmarshmallow" },
            { choiceId: "2", text: "SNOWBUNNY", image: "snowbunny" },
            { choiceId: "3", text: "FOSSIL", image: "fossil" },
          ],
        },
      },
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-3/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson03,
    },
  },
  pr04: {
    id: "pr04",
    data: {
      polls: {
        frogstates: {
          display: 1,
          label: "Poll 1",
          pollId: "frogstates",
          question: "Which state blocks will help us get past the grass?",
          choices: [
            {
              choiceId: "1",
              text: "OPEN AND SHUT",
              image: ["text_open", "text_and", "text_shut"],
            },
            {
              choiceId: "2",
              text: "OPEN AND PUSH",
              image: ["text_open", "text_and", "text_push"],
            },
            {
              choiceId: "3",
              text: "SHUT AND PUSH",
              image: ["text_shut", "text_and", "text_push"],
            },
          ],
        },
      },
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-4/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson04,
    },
  },
  pr05: {
    id: "pr05",
    data: {
      polls: {
        beforediscuss: {
          display: 1,
          label: "Poll 1",
          pollId: "beforediscuss",
          question: "Who's correct about which chamber to enter first?",
          choices: [
            {
              choiceId: "1",
              text: "MOREL",
              image: "morel",
            },
            {
              choiceId: "2",
              text: "ZORRO",
              image: "zorro",
            },
            {
              choiceId: "3",
              text: "ENOKI",
              image: "enoki",
            },
            {
              choiceId: "4",
              text: "OLIVE",
              image: "olive",
            },
          ],
        },
        afterdiscuss: {
          display: 2,
          label: "Poll 2",
          pollId: "afterdiscuss",
          question: "Who's correct about which chamber to enter first?",
          choices: [
            {
              choiceId: "1",
              text: "MOREL",
              image: "morel",
            },
            {
              choiceId: "2",
              text: "ZORRO",
              image: "zorro",
            },
            {
              choiceId: "3",
              text: "ENOKI",
              image: "enoki",
            },
            {
              choiceId: "4",
              text: "OLIVE",
              image: "olive",
            },
          ],
        },
      },
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-5/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson05,
    },
  },
  pr06: {
    id: "pr06",
    data: {
      polls: {
        firsttransform: {
          display: 1,
          label: "Poll 1",
          pollId: "firsttransform",
          question: "Which transformation should Sol and Olive write first?",
          choices: [
            {
              choiceId: "1",
              text: "STARFISH IS SANDCASTLE",
              image: ["text_star", "text_is", "text_castle"],
            },
            {
              choiceId: "2",
              text: "STARFISH IS BUBBLE",
              image: ["text_star", "text_is", "text_bubble"],
            },
            {
              choiceId: "3",
              text: "SANDCASTLE IS BUBBLE",
              image: ["text_castle", "text_is", "text_bubble"],
            },
          ],
        },
        secondtransform: {
          display: 2,
          label: "Poll 2",
          pollId: "secondtransform",
          question: "Which transformation should Sol and Olive write next?",
          choices: [
            {
              choiceId: "1",
              text: "STARFISH IS SANDCASTLE",
              image: ["text_star", "text_is", "text_castle"],
            },
            {
              choiceId: "2",
              text: "STARFISH IS BUBBLE",
              image: ["text_star", "text_is", "text_bubble"],
            },
            {
              choiceId: "3",
              text: "SANDCASTLE IS BUBBLE",
              image: ["text_castle", "text_is", "text_bubble"],
            },
          ],
        },
        predicttransform: {
          display: 3,
          label: "Poll 3",
          pollId: "predicttransform",
          question:
            "After Sol writes the rules on the left in this order, what will the objects on the right be?",
          choices: [
            {
              choiceId: "1",
              text: "BALLS",
              image: "ball",
            },
            {
              choiceId: "2",
              text: "STARFISH",
              image: "star",
            },
            {
              choiceId: "3",
              text: "BUBBLES",
              image: "bubble",
            },
          ],
        },
      },
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-6/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson06,
    },
  },
  pr06v2: {
    id: "pr06v2",
    data: {
      polls: {
        predicttransform: {
          display: 1,
          label: "Poll 1",
          pollId: "predicttransform",
          question:
            "After Sol writes the rules on the left in this order, what will the objects on the right be?",
          choices: [
            {
              choiceId: "1",
              text: "BALLS",
              image: "ball",
            },
            {
              choiceId: "2",
              text: "STARFISH",
              image: "star",
            },
            {
              choiceId: "3",
              text: "BUBBLES",
              image: "bubble",
            },
          ],
        },
      },
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-6-v2/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson06v2,
    },
  },
  pr07: {
    id: "pr07",
    data: {
      // pr07 does not have poll data
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-7/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson07,
    },
  },
  pr07v2: {
    id: "pr07v2",
    data: {
      // pr07v2 does not have poll data
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-7-v2/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson07v2,
    },
  },
  pr08: {
    id: "pr08",
    data: {
      polls: {
        sacrifice: {
          display: 1,
          label: "Poll 1",
          pollId: "sacrifice",
          question: "Which block should not be pushed into the water?",
          choices: [
            {
              choiceId: "1",
              text: "FROG",
              image: "text_frog",
            },
            {
              choiceId: "2",
              text: "IS",
              image: "text_is",
            },
            {
              choiceId: "3",
              text: "PUSH",
              image: "text_push",
            },
          ],
        },
      },
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-8/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson08,
    },
  },
  pr09: {
    id: "pr09",
    data: {
      polls: {
        hotmelt: {
          display: 1,
          label: "Poll 1",
          pollId: "hotmelt",
          question:
            "After Sol writes ICE IS HOT, which object(s) will be destroyed?",
          choices: [
            { choiceId: "1", text: "SPIKE", image: "spike" },
            { choiceId: "2", text: "SNOWBEAR", image: "snowbear" },
            {
              choiceId: "3",
              text: "Both 1 & 2",
              image: ["spike", "snowbear"],
            },
          ],
        },
        openshut: {
          display: 2,
          label: "Poll 2",
          pollId: "openshut",
          question:
            "If Sol pushes the frog into the fly, which object(s) will disappear?",
          choices: [
            { choiceId: "1", text: "FROG", image: "frog" },
            { choiceId: "2", text: "FLY", image: "fly" },
            {
              choiceId: "3",
              text: "Both 1 & 2",
              image: ["frog", "fly"],
            },
          ],
        },
        transformation: {
          display: 3,
          label: "Poll 3",
          pollId: "transformation",
          question: "Which rule would transform the bubble into a beach ball?",
          choices: [
            {
              choiceId: "1",
              text: "BUBBLE IS BALL",
              image: ["text_bubble", "text_is", "text_ball"],
            },
            {
              choiceId: "2",
              text: "BALL IS BUBBLE",
              image: ["text_ball", "text_is", "text_bubble"],
            },
          ],
        },
      },
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-9/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson09,
    },
  },
  pr10: {
    id: "pr10",
    data: {
      // pr10 does not have poll data
      slides:
        "https://9dots.slides.com/kristinebuerano/pilot-lesson-10/embed?postMessageEvents=true&style=hidden&byline=hidden&share=hidden",
      thumbnail: thumbnails.lesson10,
    },
  },
  "1Ctest": lesson02Data,
  lcr02: lesson02Data,
  lcr03: {
    id: "lcr03",
    data: {
      polls: {
        blockingLava: {
          display: 1,
          pollId: "blockingLava",
          label: "Poll 1",
          question: "What is blocking us from the goal? Why?",
          choices: [
            { choiceId: "1", text: "LAVA", image: "text_lavapit" },
            { choiceId: "2", text: "ICE", image: "text_frozenwater" },
            { choiceId: "3", text: "SNOW", image: "text_snow" },
          ],
        },
        choices: {
          display: 2,
          pollId: "choices",
          label: "Poll 2",
          question: "What block should you use? Marshmallow or Fossil?",
          choices: [
            {
              choiceId: "1",
              text: "Marshmallow",
              image: "text_roastedmarshmallow",
            },
            { choiceId: "2", text: "Fossil", image: "text_fossil" },
          ],
        },
        blocking: {
          display: 3,
          pollId: "blocking",
          label: "Poll 3",
          question: "What is blocking us from the goal? Why?",
          choices: [
            {
              choiceId: "1",
              text: "MARSHMALLOW",
              image: "text_roastedmarshmallow",
            },
            { choiceId: "2", text: "SPIKE", image: "text_spike" },
            { choiceId: "3", text: "SNOWBALL", image: "text_snowball" },
            { choiceId: "4", text: "SNOW-BUNNY ", image: "text_snowbunny" },
          ],
        },
        isWinChoices: {
          display: 4,
          pollId: "isWinChoices",
          label: "Poll 4",
          question: "What object block should be placed next to IS WIN?",
          choices: [
            { choiceId: "1", text: "HEART", image: "text_heart" },
            { choiceId: "2", text: "SNOWBALL", image: "text_snowball" },
            { choiceId: "3", text: "SPIKE", image: "text_spike" },
            { choiceId: "4", text: "SNOW-BEAR ", image: "text_snowbear" },
          ],
        },
      },
    },
  },
  lcr04: {
    id: "lcr04",
    data: {
      polls: {
        getClose1: {
          display: 1,
          pollId: "getClose1",
          label: "Poll 1",
          question: "What step can we take to get closer to the goal? Why?",
          choices: [
            { choiceId: "1", text: "Write BUBBLE IS OPEN AND STOP" },
            { choiceId: "2", text: "Write TOPAZ IS OPEN AND PUSH" },
            { choiceId: "3", text: "Push the topaz" },
          ],
        },
        getClose2: {
          display: 2,
          pollId: "getClose2",
          label: "Poll 2",
          question: "What step can we take to get closer to the goal? Why?",
          choices: [
            { choiceId: "1", text: "Write FROG IS OPEN" },
            { choiceId: "2", text: "Write FROG IS HOT" },
            { choiceId: "3", text: "Write FROG IS MELT" },
          ],
        },
      },
      slides:
        "https://docs.google.com/presentation/d/e/2PACX-1vSXYXC__mbptzOTpmv2q58S7B-dMkONn3ErDktrhOyBy57uTMJWvVWdqn6ouJJtffcYVujZwquahW6d/embed?start=false&loop=false&delayms=3000",
    },
  },
  lcr05: {
    id: "lcr05",
    data: {
      polls: {
        clearWaterPath: {
          display: 1,
          pollId: "clearWaterPath",
          label: "Poll 1",
          question:
            "Which state block can be used to clear a path through the water?",
          choices: [
            { choiceId: "1", text: "BOOM", image: "text_boom" },
            { choiceId: "2", text: "OPEN", image: "text_open" },
            { choiceId: "3", text: "HOT", image: "text_hot" },
          ],
        },
        removeBubble: {
          display: 2,
          pollId: "removeBubble",
          label: "Poll 2",
          question: "Which state block can be used to remove the bubble?",
          choices: [
            { choiceId: "1", text: "BOOM", image: "text_boom" },
            { choiceId: "2", text: "OPEN", image: "text_open" },
            { choiceId: "3", text: "HOT", image: "text_hot" },
          ],
        },
        removeKelp: {
          display: 3,
          pollId: "removeKelp",
          label: "Poll 3",
          question: "Which state block can be used to remove the kelp?",
          choices: [
            { choiceId: "1", text: "BOOM", image: "text_boom" },
            { choiceId: "2", text: "OPEN", image: "text_open" },
            { choiceId: "3", text: "HOT", image: "text_hot" },
          ],
        },
        chamber: {
          display: 4,
          pollId: "chamber",
          label: "Poll 4",
          question: "Which chamber should the group enter first?",
          choices: [
            { choiceId: "1", text: "1" },
            { choiceId: "2", text: "2" },
            { choiceId: "3", text: "3" },
            { choiceId: "4", text: "4" },
          ],
        },
      },
      slides:
        "https://docs.google.com/presentation/d/e/2PACX-1vThI1uh0Lvlpj70ktwjz7Hpm6fDwM_zxsgpk00mgcYJn72wB1oP9ClKWjFQKqQLBOblZZsc8Fc4qbDM/embed?start=false&loop=false&delayms=3000",
    },
  },
  lcr06: {
    id: "lcr06",
    data: {
      polls: {
        removeObstacle: {
          display: 1,
          pollId: "removeObstacle",
          label: "Poll 1",
          question: "Which obstacle should Olive and Sol try to remove?",
          choices: [
            { choiceId: "1", text: "ROCK", image: "rockstidepool" },
            { choiceId: "2", text: "SANDCASTLE", image: "castle" },
          ],
        },
        objectsWillBe1: {
          display: 2,
          pollId: "objectsWillBe1",
          label: "Poll 2",
          question:
            "If Sol writes BALL IS SPIKE and then SPIKE IS BUBBLE, all the objects will be...",
          choices: [
            { choiceId: "1", text: "BALLS", image: "ball" },
            { choiceId: "2", text: "SPIKES", image: "spike" },
            { choiceId: "3", text: "BUBBLES", image: "bubble" },
          ],
        },
        objectsWillBe2: {
          display: 3,
          pollId: "objectsWillBe2",
          label: "Poll 3",
          question:
            "If Sol writes BALL IS BUBBLE and then BALL IS SPIKE, all the objects will be...",
          choices: [
            { choiceId: "1", text: "BALLS", image: "ball" },
            { choiceId: "2", text: "SPIKES", image: "spike" },
            { choiceId: "3", text: "BUBBLES", image: "bubble" },
          ],
        },
        objectsWillBe3: {
          display: 4,
          pollId: "objectsWillBe3",
          label: "Poll 4",
          question:
            "After Sol writes BUBBLE IS HOT, BUBBLE IS SPIKE, and then SPIKE IS SINK, all the objects will be...",
          choices: [
            { choiceId: "1", text: "HOT", image: "text_hot" },
            { choiceId: "2", text: "SINK", image: "text_sink" },
            {
              choiceId: "3",
              text: "HOT AND SINK",
              image: ["text_hot", "text_and", "text_sink"],
            },
          ],
        },
      },
      slides:
        "https://docs.google.com/presentation/d/e/2PACX-1vSVfjh_G_rJxaQ4o8saJ58KLoKiRmzcfqc93D7EQRlYlR34NvqqoahOHfpLu1VtXU6pShZE0tq7qWlR/embed?start=false&loop=false&delayms=3000",
    },
  },
  lcr07: {
    id: "lcr07",
    data: {
      polls: {
        notDestroyed: {
          display: 1,
          pollId: "notDestroyed",
          label: "Poll 1",
          question:
            "Which object will NOT be destroyed if Sol writes GRASS IS BOOM?",
          choices: [
            { choiceId: "1", text: "Mushroom", image: "mush" },
            { choiceId: "2", text: "Starfish", image: "star" },
            { choiceId: "3", text: "Heart", image: "heart" },
          ],
        },
        heart: {
          display: 2,
          pollId: "heart",
          label: "Poll 2",
          question:
            "Which object will the heart be on if Sol takes 2 steps to the right?",
          choices: [
            { choiceId: "1", text: "Sandcastle", image: "castle" },
            { choiceId: "2", text: "Chicken", image: "chicken" },
            { choiceId: "3", text: "Grass", image: "grass" },
          ],
        },
      },
      slides:
        "https://docs.google.com/presentation/d/e/2PACX-1vSVfjh_G_rJxaQ4o8saJ58KLoKiRmzcfqc93D7EQRlYlR34NvqqoahOHfpLu1VtXU6pShZE0tq7qWlR/embed?start=false&loop=false&delayms=3000",
    },
  },
  lcr08: {
    id: "lcr08",
    data: {
      polls: {
        solveProblem1: {
          display: 1,
          pollId: "solveProblem1",
          label: "Poll 1",
          question:
            "What's the first thing we should do when we start working on a problem?",
          choices: [
            { choiceId: "1", text: "Plan the solution." },
            { choiceId: "2", text: "Reflect on the solution." },
            { choiceId: "3", text: "Understand the problem." },
            { choiceId: "4", text: "Try the solution." },
          ],
        },
        solveProblem2: {
          display: 2,
          pollId: "solveProblem2",
          label: "Poll 2",
          question: "What should the team do next to solve the problem?",
          choices: [
            { choiceId: "1", text: "Plan the solution." },
            { choiceId: "2", text: "Reflect on the solution." },
            { choiceId: "3", text: "Understand the problem." },
            { choiceId: "4", text: "Try the solution." },
          ],
        },
        solveProblem3: {
          display: 3,
          pollId: "solveProblem3",
          label: "Poll 3",
          question: "What should the team do next to solve the problem?",
          choices: [
            { choiceId: "1", text: "Plan the solution." },
            { choiceId: "2", text: "Reflect on the solution." },
            { choiceId: "3", text: "Understand the problem." },
            { choiceId: "4", text: "Try the solution." },
          ],
        },
        // solveProblem4: {
        //   display: 4,
        //   pollId: "solveProblem4",
        //   label: "Poll 4",
        //   question: "What should the team do next to solve the problem?",
        //   choices: [
        //     { choiceId: "1", text: "Plan the solution." },
        //     { choiceId: "2", text: "Reflect on the solution." },
        //     { choiceId: "3", text: "Understand the problem." },
        //     { choiceId: "4", text: "Try the solution." },
        //   ],
        // },
        shouldNotPush: {
          display: 4,
          pollId: "shouldNotPush",
          label: "Poll 4",
          question: "Which block should NOT be pushed into the water?",
          choices: [
            { choiceId: "1", text: "FROG", image: "text_frog" },
            { choiceId: "2", text: "IS", image: "text_is" },
            { choiceId: "3", text: "PUSH", image: "text_push" },
          ],
        },
        chickenState: {
          display: 5,
          pollId: "chickenState",
          label: "Poll 5",
          question:
            "After the rule CHICKEN IS SINK AND PUSH is written, which state(s) will the chicken have?",
          choices: [
            {
              choiceId: "1",
              text: "SINK AND PUSH",
              image: ["text_sink", "text_and", "text_push"],
            },
            { choiceId: "2", text: "SINK", image: "text_sink" },
            { choiceId: "3", text: "PUSH", image: "text_push" },
          ],
        },
        // waterState: {
        //   display: 7,
        //   pollId: "waterState",
        //   label: "Poll 7",
        //   question:
        //     "After the rules WATER IS NOT SINK and WATER IS NOT HOT are written, which state will water have?",
        //   choices: [
        //     { choiceId: "1", text: "HOT", image: "text_hot" },
        //     { choiceId: "2", text: "SINK", image: "text_sink" },
        //     { choiceId: "3", text: "PUSH", image: "text_push" },
        //   ],
        // },
      },
      slides:
        "https://docs.google.com/presentation/d/e/2PACX-1vQUC0LQmmH6NfL3XlzJiLI7Vu6Qie_PXzyA76HttjucjWiOHhOI-Drqdq-zusZJR8s_7DiyOWiNjTS3/embed?start=false&loop=false&delayms=3000",
    },
  },
  lcr09: {
    id: "lcr09",
    data: {
      polls: {
        destroy1: {
          display: 1,
          label: "Poll 1",
          pollId: "destroy1",
          question:
            "If Sol writes WATER IS SINK and LAVA IS WEAK, which object(s) will be destroyed?",
          choices: [
            { choiceId: "1", text: "Heart", image: "heart" },
            { choiceId: "2", text: "Spike", image: "spike" },
            {
              choiceId: "3",
              text: "Both 1 & 2",
              image: ["heart", "spike"],
            },
          ],
        },
        destroy2: {
          display: 2,
          label: "Poll 2",
          pollId: "destroy2",
          question:
            "If Sol writes ICE IS HOT, which object(s) will be destroyed?",
          choices: [
            { choiceId: "1", text: "Spike", image: "spike" },
            { choiceId: "2", text: "Snowbear", image: "snowbear" },
            {
              choiceId: "3",
              text: "Both 1 & 2",
              image: ["spike", "snowbear"],
            },
          ],
        },
        transform: {
          display: 3,
          label: "Poll 3",
          pollId: "transform",
          question: "Which rule would transform the beach ball into an urchin?",
          choices: [
            {
              choiceId: "1",
              text: "URCHIN IS BALL",
              image: ["text_urchin", "text_is", "text_ball"],
            },
            {
              choiceId: "2",
              text: "BALL IS URCHIN",
              image: ["text_ball", "text_is", "text_urchin"],
            },
          ],
        },
        destroy3: {
          display: 4,
          label: "Poll 4",
          pollId: "destroy3",
          question:
            "If Sol pushes the apple onto the grass, which object(s) will be destroyed?",
          choices: [
            {
              choiceId: "1",
              text: "Grass",
              image: "grass",
            },
            {
              choiceId: "2",
              text: "Apple",
              image: "apple",
            },
            {
              choiceId: "3",
              text: "Both 1 & 2",
              image: ["grass", "apple"],
            },
          ],
        },
      },
      slides:
        "https://docs.google.com/presentation/d/e/2PACX-1vQHpzfNy3eTj8r5zoqGClnd0adQgn9o7dIpdnPRnPkOyOLaK49ZE0vviy2QixA5XrU8xATQSdACc9Cl/embed?start=false&loop=false&delayms=3000",
    },
  },
};
